'use strict';

require('./lib/leaflet.fullscreen.min.js');

require('./lib/leaflet.fullscreen.css');